import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { ClassService } from './class.service';

export const clearActiveClassGuard: CanDeactivateFn<unknown> = () => {
  inject(ClassService).setActiveClass(null);
  return true;
};
